import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[logibidsTwoNumberOnly]',
  standalone: true,
})
export class TwoDigitNumberOnlyDirective {
  private regex: RegExp = /^[0-9]{0,2}$/; // Allow only 0 to 2 digits, no decimals
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Get current input value and next input value
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    // Prevent if next value does not match regex or length is more than 2 digits
    if (next && !this.regex.test(next)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = (
      event.clipboardData || window['clipboardData']
    ).getData('text');
    // If pasted input is not numbers or length > 2, prevent paste
    if (!/^\d{1,2}$/.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
